import React, { Component } from "react";
import cx from "classnames";
import { addonsTypes, addonsDefaultProps } from "../../types";
import { Addon } from "../../components"; // waiting for alias to work
import { OptimaStripes } from "../../components/common";
import styles from "./styles.less";
import PriceDisplay from "../../containers/PriceDisplay";

class Addons extends Component {
  onAddonIncrementClick = (addonCode, msg) => {
    const { id, onAddonIncrementClick } = this.props;
    onAddonIncrementClick(id, addonCode, msg);
  };

  onAddonDecrementClick = addonCode => {
    const { id, onAddonDecrementClick } = this.props;
    onAddonDecrementClick(id, addonCode);
  };

  onCancel = () => {
    const { onCancel, id } = this.props;
    onCancel(id);
  };

  onConfirm = () => {
    const { onConfirm, id } = this.props;
    onConfirm(id);
  };

  render() {
    const {
      addons,
      selectedAddonsGroup,
      roomNumber,
      isRtl,
      headerTitle,
      subHeaderTitle,
      confirmTitle,
      noThanksTitle
    } = this.props;
    return (
      <React.Fragment>
        <OptimaStripes />
        <div className={styles.addons}>
          <div className={styles.headers}>
            <div className={styles.header}>{headerTitle}</div>
            <div className={styles.subHeader}>
              ( {subHeaderTitle} {roomNumber} )
            </div>
          </div>
          <div className={styles.list}>
            {addons.map((addon, i) => (
              <PriceDisplay
                key={i}
                price={addon.price}
                currentCurrencyCode={addon.currencyCode}
                fallBackCurrencySymbol={addon.currency}
              >
                {convertedPrice => (
                  <Addon
                    {...addon}
                    price={convertedPrice}
                    amount={selectedAddonsGroup[addon.id] || 0}
                    onIncrement={this.onAddonIncrementClick}
                    onDecrement={this.onAddonDecrementClick}
                    isRtl={isRtl}
                  />
                )}
              </PriceDisplay>
            ))}
          </div>
          <div className={styles.actions}>
            <button
              className={cx(styles.actionBtn, styles.cancelBtn)}
              onClick={this.onCancel}
              onKeyDown={this.onCancel}
            >
              {noThanksTitle}
            </button>
            <button
              className={cx(styles.actionBtn, styles.confirmBtn)}
              onClick={this.onConfirm}
              onKeyDown={this.onConfirm}
            >
              {confirmTitle}
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Addons.defaultProps = addonsDefaultProps;

Addons.propTypes = addonsTypes;

export default Addons;



// WEBPACK FOOTER //
// ./src/components/Addons/Addons.js